import { jsx, jsxs } from 'react/jsx-runtime';
import { Icon } from '../icon.js';

function Plane(props) {
  return /* @__PURE__ */ jsx(Icon, { ...props, children: /* @__PURE__ */ jsxs(
    "svg",
    {
      "aria-labelledby": "plane-icon",
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      role: "img",
      children: [
        /* @__PURE__ */ jsx("title", { id: "plane-icon", children: "A plane icon" }),
        /* @__PURE__ */ jsx("path", { d: "M12.0056 21.0035L9.26552 21.799C9.06518 21.8579 8.8884 21.8285 8.73519 21.7106C8.58199 21.5928 8.50538 21.4395 8.50538 21.251L8.50538 20.8267C8.50538 20.7324 8.52895 20.6441 8.57609 20.5616C8.62323 20.4791 8.68216 20.4142 8.75287 20.3671L10.5206 19.0236V13.5082L3.09602 15.7002C2.82496 15.7827 2.57452 15.7385 2.34471 15.5676C2.1149 15.3967 2 15.1699 2 14.887L2 14.5335C2 14.3685 2.0383 14.2241 2.1149 14.1004C2.19151 13.9766 2.29463 13.8735 2.42426 13.791L10.4853 9.01803L10.5206 3.5026C10.5206 3.10191 10.6709 2.7513 10.9714 2.45078C11.2719 2.15026 11.6225 2 12.0232 2C12.4239 2 12.7745 2.15026 13.0751 2.45078C13.3756 2.7513 13.5258 3.10191 13.5258 3.5026V9.01804L21.5515 13.7557C21.6929 13.8499 21.8049 13.9678 21.8874 14.1092C21.9699 14.2506 22.0111 14.4038 22.0111 14.5688V14.7456C22.0111 15.0756 21.8844 15.3319 21.6311 15.5146C21.3777 15.6972 21.0978 15.7414 20.7914 15.6472L13.4905 13.5082V19.0236L15.2229 20.3317C15.3172 20.4025 15.3879 20.485 15.435 20.5792C15.4822 20.6735 15.5057 20.7796 15.5057 20.8974V21.0742C15.5057 21.3099 15.4144 21.5014 15.2317 21.6487C15.0491 21.796 14.8399 21.8343 14.6042 21.7636L12.0056 21.0035Z" })
      ]
    }
  ) });
}

export { Plane as default };
